import request from "./request";
import apis from "./apis";

const {
  placeInfo,
  deletePlaceInfo,
} = apis.rent;

const place = {
  getPlaceInfo: (data: Object) => {
    return request.get(placeInfo, data);
  },
  createPlaceInfo: (data: Object) => {
    return request.post(placeInfo, data);
  },
  updatePlaceInfo: (data: Object) => {
    return request.put(placeInfo, data);
  },
  deletePlaceInfo: (id: string) => {
    return request.idDelete(deletePlaceInfo, id);
  },
};

export default place;